import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }

import { computed} from 'vue';
import Column from './Column';
import PaginatedResponse from '@/core/http/PaginatedResponse';

interface ResourceTableThProps {
	column: Column<unknown>;
	response?: PaginatedResponse<unknown>,
	sortable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceTableTh',
  props: {
    column: {},
    response: {},
    sortable: { type: Boolean, default: true }
  },
  emits: [
	'sort',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const style = computed(() => {
	const rules = {};

	if (props.column.width) {
		rules['width'] = props.column.width;
	}

	return rules;
});

const isCurrentSort = computed<boolean>(() => {
	if (props.response) {
		const sortField = props.response.sort.substr(1);

		if (sortField === props.column.sortField) {
			return true;
		}
	}

	return false;
});

const sortAscending = computed<boolean>(() => props.response?.sort.charAt(0) === '+');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("th", {
    class: _normalizeClass(_ctx.column.classList),
    style: _normalizeStyle(style.value)
  }, [
    (_ctx.column.sortField && _ctx.sortable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button-seamless",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', _ctx.column)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.column.label) + " ", 1),
          (isCurrentSort.value && sortAscending.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "↑"))
            : _createCommentVNode("", true),
          (isCurrentSort.value && !sortAscending.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "↓"))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.column.label), 1))
  ], 6))
}
}

})